import axios from 'axios';

export function integrationBlingService(data) {
  return axios.post(
    `${process.env.REACT_APP_HOST}/api/onboarding/integration/bling`,
    data
  );
}
